"use client";
import Image from "next/image";
import { GlareCard } from "../ui/glare-card";
import AnimationContainer from "../utils/animation-container";

const Platforms = () => {
    return (
        <div className="w-full h-full">
            <AnimationContainer delay={0.5}>
                <div className='mb-3 flex flex-col gap-2'>
                    <h1 className="font-medium text-[24px]">بر اساس پلتفرم</h1>
                    <p className='text-[13px] text-gray-400'>بازی‌های مورد علاقه‌ات را بر اساس پلتفرم دلخواهت پیدا کن.</p>
                </div>
                <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3">
                    <GlareCard
                        className="w-full h-full bg-[#1F1D24] transition-colors duration-300 hover:bg-red-600 rounded-xl p-4 cursor-pointer"
                        glow={{ enable: true, opacity: 0.09 }}

                    >
                        <div className="w-full h-full flex gap-4">
                            <div className="w-1/4 h-full flex justify-center items-center">
                                <div>
                                    <Image src="/images/battlenet.png" width={70} height={70} alt="" />
                                </div>
                            </div>
                            <div className="w-3/4 h-full ">
                                <div className="h-full flex flex-col justify-center items-start gap-1">
                                    <p className="text-[23px] font-medium">بازی های</p>
                                    <p className="text-[16px] font-medium">بتل نت</p>
                                </div>
                            </div>
                        </div>
                    </GlareCard>
                    <GlareCard
                        className="w-full h-full bg-[#1F1D24] transition-colors duration-300 hover:bg-blue-600 rounded-xl p-4 cursor-pointer"
                        glow={{ enable: true, opacity: 0.09 }}

                    >
                        <div className="w-full h-full flex gap-4">
                            <div className="w-1/4 h-full flex justify-center items-center">
                                <div>
                                    <Image src="/icons/windows-10.png" width={70} height={70} alt="" />
                                </div>
                            </div>
                            <div className="w-3/4 h-full ">
                                <div className="h-full flex flex-col justify-center items-start gap-1">
                                    <p className="text-[23px] font-medium">بازی های ویندوز</p>
                                    <p className="text-[16px] font-medium">Windows</p>
                                </div>
                            </div>
                        </div>
                    </GlareCard>
                    <GlareCard
                        className="w-full h-full bg-[#1F1D24] transition-colors duration-300 hover:bg-green-600 rounded-xl p-4 cursor-pointer"
                        glow={{ enable: true, opacity: 0.09 }}

                    >
                        <div className="w-full h-full flex gap-4">
                            <div className="w-1/4 h-full flex justify-center items-center">
                                <div>
                                    <Image src="/images/epicgames.png" width={70} height={70} alt="" />
                                </div>
                            </div>
                            <div className="w-3/4 h-full ">
                                <div className="h-full flex flex-col justify-center items-start gap-1">
                                    <p className="text-[23px] font-medium">بازی های</p>
                                    <p className="text-[16px] font-medium">اپیگ گیمز</p>
                                </div>
                            </div>
                        </div>
                    </GlareCard>
                    <GlareCard
                        className="w-full h-full bg-[#1F1D24] transition-colors duration-300 hover:bg-orange-600 rounded-xl p-4 cursor-pointer"
                        glow={{ enable: true, opacity: 0.09 }}

                    >
                        <div className="w-full h-full flex gap-4">
                            <div className="w-1/4 h-full flex justify-center items-center">
                                <div>
                                    <Image src="/images/steam.png" width={70} height={70} alt="" />
                                </div>
                            </div>
                            <div className="w-3/4 h-full ">
                                <div className="h-full flex flex-col justify-center items-start gap-1">
                                    <p className="text-[23px] font-medium">بازی های قدیمی</p>
                                    <p className="text-[16px] font-medium">استیم</p>
                                </div>
                            </div>
                        </div>
                    </GlareCard>

                </div>
            </AnimationContainer>
        </div>
    )
}

export default Platforms;